export default "__VITE_ASSET__C9Q8eeD___"